var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInspiringAmbianceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 2,
    fill: "#D75F04"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 33V36.0556M60.5 84.9444V88M88 60.5H84.9444M36.0556 60.5H33M79.9456 79.9456L77.7853 77.7853M43.2147 43.2147L41.0544 41.0544M79.9456 41.0544L77.7853 43.2147M43.2147 77.7853L41.0544 79.9456M72.7222 60.5C72.7222 63.7415 71.4345 66.8503 69.1424 69.1424C66.8503 71.4345 63.7415 72.7222 60.5 72.7222C57.2585 72.7222 54.1497 71.4345 51.8576 69.1424C49.5655 66.8503 48.2778 63.7415 48.2778 60.5C48.2778 57.2585 49.5655 54.1497 51.8576 51.8576C54.1497 49.5655 57.2585 48.2778 60.5 48.2778C63.7415 48.2778 66.8503 49.5655 69.1424 51.8576C71.4345 54.1497 72.7222 57.2585 72.7222 60.5Z",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspiringAmbianceIcon);
export default __webpack_public_path__ + "static/media/inspiring-ambiance-icon.13a1b5150d9f70a9026488e6b2b8ef91.svg";
export { ForwardRef as ReactComponent };